import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';

import { CuratedCategoryModel } from '@app/core/models';
import {
  ICategoryListGetRequest,
  ICuratedCategoryApiModel,
} from '@app/core/models/api';

@Injectable()
export class CategoryApiService {
  constructor(private http: HttpClient) {}

  getCuratedCategoriesByCluster(
    clusterId: number | null,
  ): Observable<Array<CuratedCategoryModel>> {
    let req: ICategoryListGetRequest = {
      is_tag: '0',
    };

    if (clusterId != null) {
      req.cluster_id = clusterId;
    }

    return this.getCuratedCategoryList(req);
  }

  // getRegularCategories(): Observable<any> {
  //   return this.http.get(`${environment.API_URL}v5/categories.regular.json`);
  // }

  // getBusinessCollections(
  //   username: string,
  // ): Observable<Array<CuratedCategoryModel>> {
  //   return this.getCuratedCategoryList({
  //     user: username,
  //     is_tag: '0',
  //   });
  // }

  getCategoryDetails(id: number): Observable<CuratedCategoryModel> {
    const params = new HttpParams().append('category', `${id}`);

    return this.http
      .get<ICuratedCategoryApiModel>(
        `${environment.API_URL}v5/category.curated.json`,
        {
          params,
        },
      )
      .pipe(map(res => new CuratedCategoryModel(res)));
  }

  getCategoryDetailsBySlug(slug: string): Observable<CuratedCategoryModel> {
    const params = new HttpParams().append('slug', `${slug}`);

    return this.http
      .get<ICuratedCategoryApiModel>(
        `${environment.API_URL}v5/category.curated.json`,
        {
          params,
        },
      )
      .pipe(map(res => new CuratedCategoryModel(res)));
  }

  private getCuratedCategoryList(
    req: ICategoryListGetRequest,
  ): Observable<Array<CuratedCategoryModel>> {
    return this.http
      .get<Array<ICuratedCategoryApiModel>>(
        `${environment.API_URL}v5/categories.curated.json`,
        {
          params: new HttpParams({ fromObject: req as any }),
        },
      )
      .pipe(map(res => res.map(item => new CuratedCategoryModel(item))));
  }
}
